import { Injectable } from '@angular/core';
import { Machine } from '../../plant-configuration';
import { convertUnits, velPercent } from '../../util/production.util';

@Injectable()
export class UnitService{
    constructor(){

    }

    convertUnits(machine:any, value, sensorId){
        return convertUnits(machine, value, sensorId);
    }

    //Obtiene el procentaje de velocidad con respecto a velocidad máxima de la máquina seleccionada
    velPercent(vel: number, machine: Machine) {
        return velPercent(vel, machine);
    }
}